export const eventPopulate = 'cam-context-switcher-populate';
export const eventContextChanged = 'cam-context-switcher-context-changed';
export const eventOrganizationChanged = 'cam-context-switcher-organization-changed';
export const eventCostcenterChanged = 'cam-context-switcher-costcenter-changed';
export const eventWorkspaceChanged = 'cam-context-switcher-workspace-changed';
export const eventContextSwitcherReady = 'cam-context-switcher-ready';

export const defaultConfig = {
  apiUrl: 'https://cam.ctl.io'
};



// WEBPACK FOOTER //
// ./src/cam-context-switcher/scripts/cam-context-switcher-constants.js